module.exports = __webpack_public_path__ + "img/map.e284c1e7.svg";